<template>
  <!--====== sp-vpn FEATURES PART START ======-->
    <section class="sp-vpn-features-area pt-100 pb-100" id="features">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-3">
                    <div class="sp-vpn-features-tabs-btn">
                        <div class="nav flex-column nav-pills"  role="tablist" aria-orientation="vertical">
                            <a @click.prevent="selectFeature('report')" class="nav-link" :class="[selectedTab==='report'?'active':'']"  data-toggle="pill" role="tab" aria-controls="v-pills-profile" aria-selected="false"><i class="fas fa-globe-europe"></i> Выберите сервер</a>
                            <a @click.prevent="selectFeature('notice')" class="nav-link" :class="[selectedTab==='notice'?'active':'']"  data-toggle="pill"  role="tab" aria-controls="v-pills-messages" aria-selected="false"><i class="fas fa-lock"></i> Установите WireGuard</a>
                            <a @click.prevent="selectFeature('lock')" class="nav-link" :class="[selectedTab==='lock'?'active':'']" data-toggle="pill"  role="tab" aria-controls="v-pills-settings" aria-selected="false"><i class="fas fa-file"></i> Загрузите файл в WG</a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-9">
                    <div class="tab-content" >
                            <div :class="[selectedTab==='report'?'active show':'']"  class="tab-pane fade"  role="tabpanel" aria-labelledby="v-pills-profile-tab">
                                <div class="row align-items-center">
                                    <div class="col-lg-6">
                                        <div class="sp-vpn-features-thumb text-center animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="200ms">
                                            <img src="@/assets/images/select-server.png" alt=""/>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="sp-vpn-features-content animated fadeInRight" data-wow-duration="2000ms" data-wow-delay="600ms">
                                          <span>Как установить VPN</span>
                                            <h3 class="title">Выберите <br/> сервер из предложенных</h3>
                                            <p></p>
                                          <a class="main-btn" href="/#plans">Выбрать тариф</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :class="[selectedTab==='notice'?'active show':'']"  class="tab-pane fade"  role="tabpanel" aria-labelledby="v-pills-messages-tab">
                                <div class="row align-items-center">
                                    <div class="col-lg-6">
                                        <div class="sp-vpn-features-thumb text-center animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="200ms">
                                            <img src="@/assets/images/install-wg.png" alt=""/>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                      <div class="sp-vpn-features-content animated fadeInRight" data-wow-duration="2000ms" data-wow-delay="600ms">
                                        <span>Как установить VPN</span>
                                        <h3 class="title">Установите <br/> приложение WireGuard</h3>
                                        <p></p>
                                        <a class="main-btn" href="/#plans">Выбрать тариф</a>
                                      </div>
                                    </div>
                                </div>
                            </div>
                            <div :class="[selectedTab==='lock'?'active show':'']" class="tab-pane fade"  role="tabpanel" aria-labelledby="v-pills-settings-tab">
                                <div class="row align-items-center">
                                    <div class="col-lg-6">
                                        <div class="sp-vpn-features-thumb text-center animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="200ms">
                                            <img src="@/assets/images/add-config.png" alt=""/>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                      <div class="sp-vpn-features-content animated fadeInRight" data-wow-duration="2000ms" data-wow-delay="600ms">
                                        <span>Как установить VPN</span>
                                        <h3 class="title">Установите<br/> свой VPN</h3>
                                        <p></p>
                                        <a class="main-btn" href="/#plans">Выбрать тариф</a>
                                      </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="features-shape-1">
            <img src="@/assets/images/shape/shape-6.png" alt="">
        </div>
        <div class="features-shape-2">
            <img src="@/assets/images/shape/shape-7.png" alt="">
        </div>
        <div class="features-shape-3">
            <img src="@/assets/images/shape/shape-8.png" alt="">
        </div>
    </section>

    <!--====== sp-vpn FEATURES PART ENDS ======-->
</template>

<script>
export default {
    data(){
        return{
            selectedTab:'report',
            switchPlan:true,
        }
    },
    methods:{
         selectFeature(name){
            this.selectedTab=name
        },
    }
}
</script>

<style>


</style>
